<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เพิ่มข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">ลบข้อมูลเรียบร้อย !</v-alert>
        <v-alert type="error" class="alert" v-if="alert_danger === true">เกิดข้อผิดพลาด !</v-alert>
      </v-slide-x-reverse-transition>
      <div class="mt-6">
        <v-card elevation="6">
          <div class="pa-4">
            <span style="font-size: 24px">ตั้งราคาขาย</span>
          </div>
          <div class="pa-4">
            <v-data-table :headers="sales_header" :items="getProductList" mobile-breakpoint="0" hide-default-footer>
              <template slot="item" slot-scope="dataDetail">
                <tr>
                  <td>{{ dataDetail.item.u_name }}</td>
                  <td>
                    <div class="mt-3 pa-2">
                      <v-text-field
                        type="number"
                        pattern="[0-9]*"
                        @keypress="isCurrency($event, dataDetail.item.retail_price)"
                        @blur="edit_settingSale(dataDetail.item.id, dataDetail.item.u_id, 1)"
                        v-model="dataDetail.item.retail_price"
                        color="#8cc63e"
                        label="ราคาขายปลีก"
                        hide-details="auto"
                        required
                        outlined
                      ></v-text-field>

                    </div>
                  </td>
                  <td>
                    <div class="mt-3 pa-2">
                      <v-text-field
                        type="number"
                        pattern="[0-9]*"
                        @keypress="isCurrency($event, dataDetail.item.cash_price)"
                        @blur="edit_settingSale(dataDetail.item.id, dataDetail.item.u_id, 2)"
                        v-model="dataDetail.item.cash_price"
                        color="#8cc63e"
                        label="ราคาขายส่ง(สด)"
                        hide-details="auto"
                        required
                        outlined
                      ></v-text-field>
                    </div>
                  </td>
                  <td>
                    <div class="mt-3 pa-2">
                      <v-text-field
                        type="number"
                        pattern="[0-9]*"
                        @keypress="isCurrency($event, dataDetail.item.credit_price)"
                        @blur="edit_settingSale(dataDetail.item.id, dataDetail.item.u_id, 3)"
                        v-model="dataDetail.item.credit_price"
                        color="#8cc63e"
                        label="ราคาขายส่ง(เครดิต)"
                        hide-details="auto"
                        required
                        outlined
                      ></v-text-field>
                    </div>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios.js";
import {onlyForCurrency} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: { isDark: false },
    },
  },
  name: "SetInitial_Sales",
  emits: ['submitSetInitial'],
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      alert_danger: false,
      alert_error: false,
      isProcessing: {},
      makeHeader: [
        {
          text: '',
          value: 'product_name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'ราคาขายปลีก',
          value: 'retail_price',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาขายส่ง(สด)',
          value: 'cash_price',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาขายส่ง(เครดิต)',
          value: 'credit_price',
          fixed: true,
          width: '200px',
        },
      ],
      makeList: [
        {
          id: 1,
          product_name: 'กล่อง',
          fixed: true,
          width: '150px',
        },
        {
          id: 2,
          product_name: 'แพ็ค',
          fixed: true,
          width: '150px',
        },
        {
          id: 3,
          product_name: 'ซอง',
          fixed: true,
          width: '150px',
        },
      ],
      sales_header: [
        {
          text: '',
          value: '',
          sortable: false,
          fixed: true,
          width: '100px',
        },
        {
          text: 'ราคาขายปลีก',
          value: 'retail_price',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาขายส่ง(สด)',
          value: 'cash_price',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ราคาขายส่ง(เครดิต)',
          value: 'credit_price',
          fixed: true,
          width: '200px',
        },
      ],
      input_sale: {
        retail: null,
        cash: null,
        credit: null,
      },
      getProductList: [],
      product_list:[]
     
    }
  },
  methods: {
    getProduct_list() {
      const id = this.$route.params.id;
      this.loading_page = true
      HTTP.post('/products/productlist/show/' + id)
          .then((res) => {
            if (res.data.success === true){
              this.loading_page = false
              this.getProductList = res.data.set_product_price;
            }
          })
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },

    async edit_settingSale(id, unit_id, set) {
      const getProduct = this.getProductList.find((detail) => detail.id == id);
      if (!getProduct) return;
      this.savePrice({
          id: id,
          unit_id: unit_id,
          set: set,
          product_id: this.$route.params.id,
          retail_price: getProduct.retail_price,
          cash_price: getProduct.cash_price,
          credit_price: getProduct.credit_price,
        })
      
      // try {
      //   const response = await HTTP.post('/productsetprice/edit', {
      //     id: id,
      //     unit_id: unit_id,
      //     set: set,
      //     product_id: this.$route.params.id,
      //     retail_price: getProduct.retail_price,
      //     cash_price: getProduct.cash_price,
      //     credit_price: getProduct.credit_price,
      //   });

      //   if (response.data.success) {
      //     this.alert_success = true;
      //     setTimeout(() => (this.alert_success = false), 1000);
      //   } else {
      //     this.alert_error = true;
      //     setTimeout(() => (this.alert_error = false), 5000);
      //   }
      // } catch (error) {
      //   console.error("Error updating product price:", error);
      //   this.alert_error = true;
      //   setTimeout(() => (this.alert_error = false), 5000);
      // }
    },
    savePrice(data){
      this.$emit('submitSetInitial',data)
    },

  },
  beforeMount() {
    this.getProduct_list();
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
</style>
